// Espelha FuncionarioDocumentacaoAcessoriaService.tratamentoVariaveis() e replaceDetalhesImpressao()
// no mbs-api, mais as variáveis do romaneio (PedidoUniformeService.aplicarVariaveisRomaneioModelo()).
// @FuncionarioReciclagemVencimento fica de fora: o back-end só a reconhece com um caractere invisível
// (U+200C) depois do @, então digitada normalmente ela sai em branco.
const variaveisFixas = Array.from({ length: 10 }, (_, indice) => {
  const numero = String(indice + 1).padStart(2, "0");
  return {
    nome: `VariavelFixa${numero}`,
    chave: "VariavelFixa",
    parametros: { numero },
  };
});

export default {
  namespace: "variaveisTexto.documentacaoAcessoria",
  observacoes: ["formato", "ausente", "lancamentos", "html"],
  grupos: [
    {
      chave: "documento",
      variaveis: [
        "TituloRelatorio",
        "DataGeracao",
        "DataAssinatura",
        "Assinatura",
        "ImpressaoUsuario",
        "ImpressaoData",
        "ImpressaoHora",
      ],
    },
    {
      chave: "funcionario",
      variaveis: [
        "FuncionarioMatricula",
        "FuncionarioNome",
        "FuncionarioCpf",
        "FuncionarioDataNascimento",
        "FuncionarioSexo",
        "FuncionarioCor",
        "FuncionarioEstadoCivil",
        "FuncionarioGrauInstrucao",
        "FuncionarioNacionalidade",
        "FuncionarioNaturalidadeCidade",
        "FuncionarioNaturalidadeUf",
        "FuncionarioPai",
        "FuncionarioMae",
        "FuncionarioConjugueNome",
        "FuncionarioPossuiDeficiencia",
        "FuncionarioEmail",
        "PessoaImagem",
      ],
    },
    {
      chave: "documentosPessoais",
      variaveis: [
        "FuncionarioRgNumero",
        "FuncionarioRgEmissao",
        "FuncionarioRgOrgaoUf",
        "FuncionarioPis",
        "FuncionarioCtpsNumero",
        "FuncionarioCtpsSerie",
        "FuncionarioTitulo",
        "FuncionarioZonaTitulo",
        "FuncionarioSecaoTitulo",
        "FuncionarioCnh",
        "FuncionarioCnhCategoria",
        "FuncionarioReservistaNumero",
        "FuncionarioReservistaCategoria",
      ],
    },
    {
      chave: "enderecoFuncionario",
      variaveis: [
        "FuncionarioEnderecoLogradouro",
        "FuncionarioEnderecoNumero",
        "FuncionarioEnderecoComplemento",
        "FuncionarioEnderecoBairro",
        "FuncionarioEnderecoCep",
        "FuncionarioEnderecoCidade",
        "FuncionarioEnderecoUf",
      ],
    },
    {
      chave: "contrato",
      variaveis: [
        "FuncionarioDataAdmissao",
        "FuncionarioDataEncerramento1PeriodoExperiencia",
        "FuncionarioDataEncerramento2PeriodoExperiencia",
        "FuncionarioCargoDescricao",
        "FuncionarioCargoCbo",
        "FuncionarioCargoObservacao",
        "FuncionarioSalarioBase",
        "FuncionarioSalarioBaseExtenso",
        "FuncionarioUnidadeSalario",
        "FuncionarioSindicato",
        "FuncionarioEscalaTrabalho",
        "FuncionarioHorario",
        "FuncionarioOptanteVT",
      ],
    },
    {
      chave: "dadosBancarios",
      variaveis: [
        "FuncionarioContaBancariaBanco",
        "FuncionarioContaBancariaAgencia",
        "FuncionarioContaBancariaNumero",
        "FuncionarioContaBancariaOperacao",
        "FuncionarioChavePix",
      ],
    },
    {
      chave: "postoTrabalho",
      variaveis: [
        "FuncionarioPostoTrabalho",
        "FuncionarioCargoPostoTrabalho",
        "FuncionarioEscalaPostoTrabalho",
        "FuncionarioClienteRazaoSocialPostoTrabalho",
        "FuncionarioRazaoSocialTomadorPostoTrabalho",
        "FuncionarioEnderecoPostoTrabalhoLogradouro",
        "FuncionarioEnderecoPostoTrabalhoNumero",
        "FuncionarioEnderecoPostoTrabalhoBairro",
        "FuncionarioEnderecoPostoTrabalhoCidade",
        "FuncionarioEnderecoPostoTrabalhoUf",
      ],
    },
    {
      chave: "movimentacao",
      variaveis: [
        "FuncionarioMovimentacaoData",
        "FuncionarioMovimentacaoObservacao",
      ],
    },
    {
      chave: "dependentes",
      variaveis: [
        "dependentesNomeCPFNascimento",
        "dependentesNomeCPF",
        "TemDependenteCadastrado",
        "TemDependenteIrrf",
        "TemDependenteSalarioFamilia",
        "TemDependenteIncapacidadeFisica",
      ],
    },
    {
      chave: "empresa",
      variaveis: [
        "EmpresaRazaoSocial",
        "EmpresaCnpj",
        "EmpresaLogradouro",
        "EmpresaNumeroEndereco",
        "EmpresaBairro",
        "EmpresaCep",
        "EmpresaCidade",
        "EmpresaUf",
        "EmpresaLogo",
      ],
    },
    {
      chave: "afastamento",
      variaveis: [
        "AfastamentoDataInicio",
        "AfastamentoDataFim",
        "AfastamentoDataRetorno",
        "AfastamentoDuracaoDiasNumeral",
        "AfastamentoDuracaoDiasExtenso",
        "Afastamento02DiasAntesDataInicio",
        "Afastamento03DiasAntesDataInicio",
        "Afastamento30DiasAntesDataInicio",
        "Afastamento31DiasAntesDataInicio",
        "AfastamentoPeriodoAquisitivoInicio",
        "AfastamentoPeriodoAquisitivoFinal",
        "AfastamentoDiasAbono",
        "AfastamentoObservacao",
      ],
    },
    {
      chave: "avisoPrevio",
      variaveis: [
        "AvisoPrevioDataInicio",
        "AvisoPrevioDataFim",
        "AvisoPrevio10DiasDepoisDataInicio",
        "AvisoPrevio10DiasDepoisDataFim",
        "AvisoPrevioTipo",
        "AvisoPrevioBeneficio",
        "AvisoPrevioOrigem",
        "AvisoPrevioDataHomologacao",
      ],
    },
    {
      chave: "romaneioUniforme",
      variaveis: [
        "UniformeRomaneioTabelaProdutos",
        "UniformeRomaneioTabelaProdutosSemDevolucao",
        "UniformeRomaneioAssinaturas",
      ],
    },
    {
      chave: "variaveisFixas",
      variaveis: variaveisFixas,
    },
  ],
};
